module.exports = __webpack_public_path__ + "static/media/assignments.4e96f34b.svg";